var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { bindApp } from '../helpers';
import { getActiveUi } from '../resolveCanvasTheme';
/** Live canvas UI palette (synced from app theme). */
export function UI() {
    return getActiveUi();
}
export function createGroup(app, type, props, extra) {
    var _a;
    if (extra === void 0) { extra = {}; }
    var extraMeta = (_a = extra.metadata) !== null && _a !== void 0 ? _a : {};
    var extraState = extraMeta.componentState && typeof extraMeta.componentState === 'object'
        ? extraMeta.componentState
        : {};
    var extraRest = __assign({}, extra);
    delete extraRest.metadata;
    var group = app.group(__assign(__assign(__assign(__assign({}, props), { listening: true }), extraRest), { metadata: __assign(__assign({ componentType: type }, extraMeta), { 
            // Keep props (including uiTheme) then factory-specific state
            componentState: __assign(__assign({}, props), extraState) }) }));
    bindApp(group, app);
    return group;
}
/** Shared canvas surface chrome — consistent radius, border, shadow across UI components */
export function canvasSurface(app, width, height, opts) {
    var _a;
    if (opts === void 0) { opts = {}; }
    return app.roundedRect({
        width: width,
        height: height,
        cornerRadius: (_a = opts.radius) !== null && _a !== void 0 ? _a : UI().radius,
        fill: UI().surface,
        stroke: UI().border,
        strokeWidth: 1,
        shadow: opts.elevated ? UI().shadowLg : UI().shadowSm,
        listening: false,
    });
}
